module.exports = __webpack_public_path__ + "static/media/1.2724f25f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/21-007/1.jpg
// module id = 628
// module chunks = 0